import styles from './spinner.module.scss';
export function Spinner() {
    return (
        <div className={styles.spinner}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}
